module.exports = __webpack_public_path__ + "static/img/center_img2.964ba773.jpg";